import React from "react";
import ContentViewer from "./ContentViewer";
import ColorPicker from "./ColorPicker";
import { useTextHighlight } from "@/hooks/useTextHighlight";

interface HighlightableContentProps {
  content: string;
  contentType: "passage" | "question";
  onSaveHighlight?: (
    contentType: "passage" | "question",
    newContent: string
  ) => void;
  className?: string;
}

const HighlightableContent: React.FC<HighlightableContentProps> = ({
  content,
  contentType,
  onSaveHighlight,
  className,
}) => {
  const {
    showColorPicker,
    colorPickerPosition,
    handleTextSelected,
    handleCloseColorPicker,
    handleColorSelect,
  } = useTextHighlight({
    contentType,
    onSaveHighlight,
  });

  return (
    <div className={className}>
      <ContentViewer
        content={content}
        contentType={contentType}
        onTextSelected={handleTextSelected}
      />
      {/* ColorPicker */}
      {showColorPicker && (
        <ColorPicker
          x={colorPickerPosition.x}
          y={colorPickerPosition.y}
          onClose={handleCloseColorPicker}
          onColorSelect={handleColorSelect}
        />
      )}
    </div>
  );
};

export default HighlightableContent;
